// Keep SKU photos first so specification selection still resolves to its photo.
// The CMS's separate product-picture list can contain empty upload slots.
export function getAustraliaProductImages(product = {}) {
  const skus = product.dealerItemSkuDTOList || []
  const images = skus.flatMap(sku => {
    const iconUrl = typeof sku.iconUrl === 'string' ? sku.iconUrl.trim() : ''
    return iconUrl ? [{
      iconUrl,
      id: sku.id,
      dealerItemSkuSpecReqDTOs: sku.dealerItemSkuSpecReqDTOs,
      dealerItemSpuId: sku.dealerItemSpuId,
      spItemSkuSpecificationIds: sku.spItemSkuSpecificationIds,
    }] : []
  })

  const cover = typeof product.iconUrl === 'string' ? product.iconUrl.trim() : ''
  if (!images.length && cover) {
    const firstSku = skus[0]
    images.push({
      iconUrl: cover,
      id: firstSku?.id || product.id,
      dealerItemSkuSpecReqDTOs: firstSku?.dealerItemSkuSpecReqDTOs,
      dealerItemSpuId: product.id,
      spItemSkuSpecificationIds: firstSku?.spItemSkuSpecificationIds,
    })
  }

  const pictures = Array.isArray(product.picUrls)
    ? product.picUrls
    : typeof product.picUrls === 'string' ? product.picUrls.split(',') : []
  pictures.forEach((picture, index) => {
    const iconUrl = typeof picture === 'string' ? picture.trim() : ''
    if (iconUrl) images.push({ iconUrl, id: `product-image:${index}` })
  })

  const seen = new Set()
  return images.filter(image => {
    if (seen.has(image.iconUrl)) return false
    seen.add(image.iconUrl)
    return true
  })
}
